import { render, staticRenderFns } from "./AlarmStatusColumn.vue?vue&type=template&id=5a0f0b1f&scoped=true&"
import script from "./AlarmStatusColumn.vue?vue&type=script&lang=js&"
export * from "./AlarmStatusColumn.vue?vue&type=script&lang=js&"
import style0 from "./AlarmStatusColumn.vue?vue&type=style&index=0&id=5a0f0b1f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0f0b1f",
  null
  
)

export default component.exports